import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IViewModel } from '../interfaces/view-model.interface';
import { Logging } from '../logging';
import { PickerItem } from '../models/picker-item.model';
import { BehaviorSubject, EMPTY } from 'rxjs';

@Injectable()
export class MaxPickerService {
    public isSearching = new BehaviorSubject(false);
    
    constructor(private http: HttpClient) { }

    search(query: string, max: number = 100, scope: string = 'usersAndGroups'): Promise<PickerItem[]> {
        if ((!query) || (query.length == 0)) { return EMPTY.toPromise(); }

        this.isSearching.next(true);

        let url = `${environment.apiUrl}/frameworkapi/maxpicker/search?searchstring=${query}&maxcount=${max}&scope=${scope}`;

        return this.http
            .get<PickerItem[]>(url)
            .toPromise()
            .then(response => {
                let data: PickerItem[] = [];

                response.forEach(x => {
                    data.push(new PickerItem(x));
                });
                this.isSearching.next(false);

                
                // Uncomment this to work around the picker server service not working on dev
                 this.addFakeUsers(data);

                return data;
            })
            .catch(this.handleError);
    }

    private addFakeUsers(data: PickerItem[]) {
        let pi = new PickerItem({
            key: 'O001554',
            displayName: "P J. Harvey (OMB,Ctr)",
            secondaryDisplayName: 'pharvey@omb.eop.gov',
            isUser: true,
            isActive: true,
            fullDisplay: "P J. Harvey (OMB,Ctr) - pharvey@omb.eop.gov",
            phone: "(202) 395-6955",
            phoneExt: '',
            agencyShortName: 'OMB'
        });

        data.push(pi);
        let pi2 = new PickerItem({
            key: "O437732",
            displayName: "Steve W. Gadd (OMB,Ctr)",
            secondaryDisplayName: "Steve.W.Gadd@omb.eop.gov",
            isUser: true,
            isActive: true,
            fullDisplay: "Steve W. Gadd (OMB,Ctr) - Steve.W.Gadd@omb.eop.gov",
            phone: '(202) 881-8795',
            phoneExt: '',
            agencyShortName: 'OMB'
        });
        data.push(pi2);
    }

    handleError(error: Response | any): Promise<any> {
        Logging.log(error);
        return Promise.reject(error.message || error);
    }
}
